
<template>
  <div class="index-wrap wrap wrap-tec">
    <router-view></router-view>
    <section
      v-if="
        !$route.meta.invisible && !$route.meta.invisibles && !$route.meta.show
      "
    >
      <div class="breads container">
        <bread></bread>
      </div>
      <div class="container">
        <div class="flex main-box">
          <el-menu :default-active="defaultActive" class="left-menu">
            <template v-for="(menu, index) in menuList">
              <el-submenu
                :key="index"
                v-if="menu.children"
                :index="index.toString()"
              >
                <template #title>
                  <span>{{ menu.name }}</span>
                </template>
                <el-menu-item
                  v-for="(child, childIndex) in menu.children"
                  class="left-menu-child"
                  :key="childIndex"
                  :index="child.component"
                  :component="child.component"
                  @click="handleClick(child)"
                >
                  {{ child.name }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :index="menu.component"
                :key="index"
                @click="handleClick(menu)"
              >
                <span>{{ menu.name }}</span>
              </el-menu-item>
            </template>
          </el-menu>
          <div class="main-content" >
            <component v-if="currentComponent" :is="currentComponent" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread";
export default {
  components: { bread },
  data() {
    return {
      currentComponent:null,
      defaultActive: "./DNASeq/DNASeqFormatting",
      menuList: [
        {
          name: "DNA序列分析",
          children: [
            {
              name: "DNA序列格式化",
              component: "./DNASeq/DNASeqFormatting",
            },
            {
              name: "seq文件格式转化",
              component: "./DNASeq/SeqFileFormatting",
            },
            {
              name: "DNA/氨基酸序列转换",
              component: "./DNASeq/DNASeqConvert",
            },
            {
              name: "酶切位点分析",
              component: "./DNASeq/CutSiteAnalyzer",
            },
            {
              name: "DNA重复&GC含量分析",
              component: "./DNASeq/GCContent",
            },
            {
              name: "二级结构分析",
              component: "./DNASeq/SecondaryAnalysis",
            },
          ],
        },
        {
          name: "序列比对",
          component: "./SeqAlignment/index",
        },
        {
          name: "引物设计",
          children: [
            {
              name: "引物分析工具",
              component: "./PrimerDesign/PrimerAnalysis",
            },
            {
              name: "扩增引物设计",
              component: "./PrimerDesign/AmplificationPrimerDesign",
            },
            {
              name: "测序引物设计",
              component: "./PrimerDesign/SeqPrimerDesign",
            },
            {
              name: "通用测序引物选择",
              component: "./PrimerDesign/SearchPrimerInfo",
            },
            
          ],
        },
      ],
    };
  },
  watch:{
    defaultActive:{
      immediate: true,
      handler(val) {
        if (val) {
          import(`${this.defaultActive}.vue`).then((component) => {
            this.currentComponent = component.default;
          })
          .catch((error) => {
            this.currentComponent = null
          });

        }else{
          this.currentComponent = null
        }
      },
    }
  },
  methods: {
    handleClick(val) {
      this.defaultActive = val.component
    }
  }
};
</script>
<style>
@import url("../../assets/tools.css");
</style>
<style scoped lang="scss">
.index-wrap.wrap-tec{
  margin-bottom: -50px;
  .wrap-tec{
    margin-bottom: 130px;
  }
}
.breads {
  overflow: auto;
  line-height: 48px;
}
.main-box{
  border-top: 1px solid #F5F7FA;
}
.left-menu {
  width: 200px;
  border-right: solid 6px #F5F7FA;
  .el-menu-item {
    padding: 0 10px !important;
    height: 50px;
    line-height: 50px;
    position: relative;
    z-index: 1;
    &:hover::after, &:focus::after {
      position: absolute;
      content: "";
      background: #eff5ff !important;
      left: 0;
      bottom: 5px;
      top: 5px;
      right: 10px;
      z-index: -1;
      border-radius: 5px;
    }
  }
  .left-menu-child {
    padding-left: 30px !important;
  }
  .el-menu-item:hover, .el-menu-item:focus{
    color: #014492;
    font-weight: bold;
    background-color: transparent;
  }
  /deep/ .el-submenu .el-submenu__title{
    position: relative;
    z-index: 1;
    background: transparent!important;
    color: inherit;
    font-weight: normal;
    &:focus,&:hover{
      background-color: transparent!important;
    }
    &:hover::after, &:focus::after {
      position: absolute;
      content: "";
      background: #eff5ff !important;
      left: 0;
      bottom: 5px;
      top: 5px;
      right: 10px;
      z-index: -1;
      border-radius: 5px;
    }
  }
  .el-menu-item.is-active{
    color: #014492;
    font-weight: bold;
    &:focus,&:hover{
      background: transparent;
    }
    &::after,&:hover:after {
      position: absolute;
      content: "";
      background: #eff5ff !important;
      left: 0;
      bottom: 5px;
      top: 5px;
      right: 10px;
      z-index: -1;
      border-radius: 5px;
    }
  }
}
.main-content {
  flex:1;
  padding: 15px;
  min-height: 820px;
}

</style>


// WEBPACK FOOTER //
// src/views/tools/index.vue